import React, { useEffect, useState } from 'react'
import CustomHeader from '../../components/CustomHeader'
import PAGE_TITLES from '../../consts/titles'
import { getLoadingTitle } from '../../consts/dynamicTitles'
import { Box, CircularProgress, Container, Grow, Typography } from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useNavigate } from 'react-router-dom'
import ROUTES from '../../consts/paths'
import { abortAllRequests } from '../../utils/api'
import GenericButton from '../../components/GenericButton'
import { ButtonType } from '../../components/GenericButton/styles'

export interface LoadingPageV2Props {
  title?: PAGE_TITLES
}

export const FullScreenBox = styled(Box)({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh'
})

const LoadingPageV2 = ({ title }: LoadingPageV2Props): JSX.Element => {
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'))
  const navigate = useNavigate()

  const [showHelp, setShowHelp] = useState(false)

  useEffect(() => {
    const timer = window.setTimeout(() => { setShowHelp(true) }, 10 * 1000)
    return () => { window.clearTimeout(timer) }
  }, [])

  const handleLogout = (): void => {
    try {
      abortAllRequests()
      localStorage.clear()
      sessionStorage.clear()
      navigate(ROUTES.LOGOUT)
    } catch {
      console.error('Error during logout process')
    }
  }

  const handleReload = (): void => {
    window.location.reload()
  }

  return (
    <>
      {(title != null)
        ? <CustomHeader title={title} info={PAGE_TITLES.LOADING} />
        : <CustomHeader title={PAGE_TITLES.LOADING} />
      }

      <FullScreenBox
        gap={8}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'white',
          zIndex: 9999
        }}
      >
          <CircularProgress size={104} color='primary' />
          <Typography variant="h1">
            {getLoadingTitle(title)}
          </Typography>
          {
            !showHelp &&
            <Typography variant="p3">
              Hold tight
            </Typography>}

          {showHelp && (
            <Grow in={showHelp}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 2,
                  px: isLargeScreen ? 0 : 2,
                  maxWidth: 520
                }}
              >
                <Typography variant="p3" textAlign={'center'}>
                  Loading taking too long? Try logging out and logging back in.
                </Typography>

                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center', mt: 1 }}>
                  <GenericButton buttonType={ButtonType.Primary} fontWeight='bold' label='Log out' onClick={handleLogout} />
                  <GenericButton buttonType={ButtonType.Secondary} fontWeight='bold' label='Reload' onClick={handleReload} />
                </Box>
              </Box>
            </Grow>
          )}
      </FullScreenBox>
    </>
  )
}

export default LoadingPageV2
